// extracted by mini-css-extract-plugin
module.exports = {"heroHeaderBlockTokens":"heroHeaderBlock_heroHeaderBlockTokens__nAtvi","heroHeaderBlock":"heroHeaderBlock_heroHeaderBlock__pNxdT"};